'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ../~/react/react.js
// module id = 5
// module chunks = 0